/** @flow */

import { completeRequest, beginRequest } from "@store/utils";
import { transformSort } from "@transformers/sort";
import type { StaffGroupsState } from "./types";

const finishRequest = completeRequest(["requestsInProgress"]);
const startRequest = beginRequest(["requestsInProgress"]);

export const onToggleDisableStaffGroupModal = (state: StaffGroupsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    staffGroupId: payload.staffGroupId,
    name: payload.name,
    numberEmployees: payload.numberEmployees,
    disable: {
      visible: payload.visible,
    },
  },
});

export const onToggleEditStaffGroupModal = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    staffGroupId: payload.staffGroupId,
    editStaffGroup: {
      visible: payload.visible,
      formData: payload.formData,
    },
  },
});

export const onToggleReassignStaffGroupModal = (state: StaffGroupsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    staffGroupId: payload.staffGroupId,
    name: payload.name,
    numberEmployees: payload.numberEmployees,
    disable: {
      visible: false,
    },
    reassign: {
      visible: payload.visible,
    },
  },
});

export const onShowReassignStaffGroupModal = (state: StaffGroupsState) => () => ({
  ...state,
  modals: {
    ...state.modals,
    disable: {
      visible: false,
    },
    reassign: {
      ...state.modals.reassign,
      visible: true,
    },
  },
});

export const onEditStaffGroup = (state: StaffGroupsState) => ({ payload }: Object) =>
  startRequest(state);

export const onGetStaffGroups = (state: StaffGroupsState) => ({ payload }: Object) =>
  startRequest(state);

export const onGetStaffGroupsSuccess = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});
export const onGetStaffGroupsError = (state: StaffGroupsState) => ({ payload }: Object) =>
  finishRequest(state);

export const onSetStaffGroupSchema = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  schema: {
    ...state.schema,
    staffGroup: payload,
  },
});

export const onSetStaffGroupsSchema = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  schema: {
    ...state.schema,
    staffGroups: payload,
  },
});

export const onToggleAddStaffGroupModal = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    addStaffGroup: {
      formData: null,
      visible: payload,
    },
  },
});

export const onGetStaffGroupsConfigurationSuccess = (state: StaffGroupsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  configuration: {
    ...state.configuration,
    staffGroupsEnabled: payload.staffGroupsEnabled,
  },
});

export const onSetStaffGroupsSort = (state: Object) => ({ payload }: Object) => ({
  ...state,
  ...startRequest(state),
  list: {
    ...state.list,
    pagination: {
      sort: {
        orders: transformSort(payload.sort),
      },
    },
  },
});

export const onGetTotalStaffGroups = (state: StaffGroupsState) => () => startRequest(state);

export const onGetTotalStaffGroupsSuccess = (state: StaffGroupsState) => (action: *) => ({
  ...state,
  totalList: action.payload,
  error: null,
  requestsInProgress: --state.requestsInProgress,
});

export const onGetTotalStaffGroupsError = (state: StaffGroupsState) => (action: *) => ({
  ...state,
  error: action.payload,
  requestsInProgress: --state.requestsInProgress,
});
